/* 🤖 this file was generated by svg-to-ts*/
export const iconDrag = {
  name: 'drag',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 9H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM5 15h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1z"/></svg>`,
}

/* 🤖 this file was generated by svg-to-ts*/
export const iconDragDots = {
  name: 'dragDots',
  data: `
  <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_211_23440)">
  <path d="M11 18.5C11 19.6 10.1 20.5 9 20.5C7.9 20.5 7 19.6 7 18.5C7 17.4 7.9 16.5 9 16.5C10.1 16.5 11 17.4 11 18.5ZM9 10.5C7.9 10.5 7 11.4 7 12.5C7 13.6 7.9 14.5 9 14.5C10.1 14.5 11 13.6 11 12.5C11 11.4 10.1 10.5 9 10.5ZM9 4.5C7.9 4.5 7 5.4 7 6.5C7 7.6 7.9 8.5 9 8.5C10.1 8.5 11 7.6 11 6.5C11 5.4 10.1 4.5 9 4.5ZM15 8.5C16.1 8.5 17 7.6 17 6.5C17 5.4 16.1 4.5 15 4.5C13.9 4.5 13 5.4 13 6.5C13 7.6 13.9 8.5 15 8.5ZM15 10.5C13.9 10.5 13 11.4 13 12.5C13 13.6 13.9 14.5 15 14.5C16.1 14.5 17 13.6 17 12.5C17 11.4 16.1 10.5 15 10.5ZM15 16.5C13.9 16.5 13 17.4 13 18.5C13 19.6 13.9 20.5 15 20.5C16.1 20.5 17 19.6 17 18.5C17 17.4 16.1 16.5 15 16.5Z"/>
  </g>
  <defs>
  <clipPath id="clip0_211_23440">
  <rect width="24" height="24" transform="translate(0 0.5)"/>
  </clipPath>
  </defs>
  </svg>
  `,
}
